import Enum from '@square/dashboard-utilities/utils/enum';
export const SortType = new Enum(['DEFAULT',
// this should not be used - it is for a special case when sort is not set
'DISPLAY_NAME', 'CREATED_AT', 'FIRST_VISITED_AT', 'LAST_VISITED_AT', 'SPEND_TOTAL', 'SPEND_AVERAGE', 'COUNT_TRANSACTIONS', 'RELEVANCE_SCORE']);
export const SortOrder = new Enum(['ASCENDING', 'DESCENDING']);
export const DEFAULT_SORT_TYPE = SortType.DEFAULT;
export const DEFAULT_SORT_ORDER = SortOrder.ASCENDING;
export const DEFAULT_LIST_CONTACTS_SORT_TYPE = getListContactsSortType(DEFAULT_SORT_TYPE, DEFAULT_SORT_ORDER);

// https://prototype.sqprod.co/#/docs/squareup.rolodex.ListContactsSortType
export default new Enum(['DISPLAY_NAME_ASCENDING', 'DISPLAY_NAME_DESCENDING', 'CREATED_AT_ASCENDING', 'CREATED_AT_DESCENDING', 'FIRST_VISITED_AT_ASCENDING', 'FIRST_VISITED_AT_DESCENDING', 'LAST_VISITED_AT_ASCENDING', 'LAST_VISITED_AT_DESCENDING', 'SPEND_TOTAL_ASCENDING', 'SPEND_TOTAL_DESCENDING', 'SPEND_AVERAGE_ASCENDING', 'SPEND_AVERAGE_DESCENDING', 'COUNT_TRANSACTIONS_ASCENDING', 'COUNT_TRANSACTIONS_DESCENDING', 'RELEVANCE_SCORE_ASCENDING', 'RELEVANCE_SCORE_DESCENDING']);
export function getListContactsSortType(sortType, sortOrder) {
  if (!sortType || !sortOrder) {
    return null;
  }
  // default sort type does not map to the ListContactsSortType proto
  // so we force map it to display name
  if (sortType === SortType.DEFAULT) {
    return `${SortType.DISPLAY_NAME}_${sortOrder}`;
  }
  return `${sortType}_${sortOrder}`;
}
export function extractSortTypeAndSortOrder(listContactsSortType) {
  const splitIndex = listContactsSortType.lastIndexOf('_');
  return {
    sortType: listContactsSortType.slice(0, splitIndex),
    sortOrder: listContactsSortType.slice(splitIndex + 1)
  };
}